const editCheckoutTermsConditionsConstantsEn = {
  checkoutTermsConditionsPageTitle: 'Checkout Terms and Conditions',
  checkoutTermsConditionsBreadcrumb: 'CHECKOUT TERMS AND CONDITIONS',

};

export default editCheckoutTermsConditionsConstantsEn;
